import React from 'react'
import Layout from '../../components/Layout'
import { useGetQuizsQuery } from '../../features/quiz/quizApi'
import SkeletonLoader from '../../components/ui/SkeletonLoader'
import QuizItem from '../../components/QuizItem'
import { Link } from 'react-router-dom'

export default function Quizzes() {
    const { isSuccess: isSuccessFetchQuizzes, isLoading: isLoadingFetchQuizzes, data: quizzes } = useGetQuizsQuery()

    let content;

    if (isLoadingFetchQuizzes) {
        content = <SkeletonLoader />
    }
    else if (isSuccessFetchQuizzes && quizzes?.length > 0) {
        content = quizzes.map(quiz => <QuizItem key={quiz.id} quiz={quiz} />)
    } else if (isSuccessFetchQuizzes && quizzes.length === 0) {
        content = <h2 className='text-2xl'>No assignment here.</h2>
    } else {
        content = <h2 className='text-2xl'>Something is wrong.</h2>
    }

    return (
        <Layout>
            <section className="py-6 bg-primary">
                <div className="mx-auto max-w-full px-5 lg:px-20">
                    <div className="px-3 py-20 bg-opacity-10">
                        <div className="w-full flex">
                            <Link to="/admin/add-quiz" className="btn ml-auto">Add Quiz</Link>
                        </div>
                        <div className="overflow-x-auto mt-4">
                            <table className="divide-y-1 text-base divide-gray-600 w-full">
                                <thead>
                                    <tr>
                                        <th className="table-th">Question</th>
                                        <th className="table-th">Video</th>
                                        <th className="table-th justify-center">Action</th>
                                    </tr>
                                </thead>

                                <tbody className="divide-y divide-slate-600/50">
                                    {content}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}
